import PaymentAnalytics from 'routes/PaymentAnalytics/PaymentAnalytics';

export default PaymentAnalytics;
